import { Math_LinearInterpolationX, Math_LinearInterpolationY } from "../../serviceapp/math.js";

/**
 * DrawCircle - Return array of points representing circle in XY for input parameters
 * @param {radius} - Radius of the circle
 * @param {startAngle} - Start angle of the circle
 * @param {endAngle} - End angle of the circle
 * @param {step} - Step (lower value means more points)
 * @param {roundPoints} - How many decimal places
 * @return {array} - Array of the array
 **/
export function DrawCircle(radius, startAngle, endAngle, step, roundPoints) {
  let xy = [];
  let array = [];
  let radians = 0;
  let round = Math.pow(10, roundPoints);

  if (step === 0) {
    return;
  }

  if (step <= 0.5) {
    step = 0.5;
  }

  for (let angle = startAngle; angle < endAngle; angle += step) {
    xy = [];
    // Angle to radians conversion
    radians = (angle * Math.PI) / 180;
    // X
    xy.push(Math.round(radius * Math.cos(radians) * round) / round);
    // y
    xy.push(Math.round(radius * Math.sin(radians) * round) / round);
    // Push X,Y array into array
    array.push(xy);
  }
  // return array
  return array;
}

/**
 * getYFromLinearInterpolationBetweenPoints - Return y for given x from function defined with points P0, P1, P2, P3 as Linear Interpolation between these points
 * @param {x0} - x coordinate of point P0
 * @param {y0} - y coordinate of point P0
 * @param {x1} - x coordinate of point P1
 * @param {y1} - y coordinate of point P1
 * @param {x2} - x coordinate of point P2
 * @param {y2} - y coordinate of point P2
 * @param {x3} - x coordinate of point P3
 * @param {y3} - y coordinate of point P3
 * @param {x} - x - value to calculate y - value
 * @return {y} - y - value for given x
 **/
export function getYFromLinearInterpolationBetweenPoints(x0, y0, x1, y1, x2, y2, x3, y3, x) {
  let y;

  if (x <= x0) {
    y = y0;
  } else if (x <= x1) {
    y = Math_LinearInterpolationY(x0, y0, x1, y1, x);
  } else if (x <= x2) {
    y = Math_LinearInterpolationY(x1, y1, x2, y2, x);
  } else if (x <= x3) {
    y = Math_LinearInterpolationY(x2, y2, x3, y3, x);
  } else {
    y = y3;
  }

  return y;
}

/**
 *
 **/
export function DrawLine(x0, y0, x1, y1, step, roundPoints, horizontal) {
  let array = [];
  let round = Math.pow(10, roundPoints);

  let beginLoop;
  let endLoop;

  let beginX, beginY, endX, endY;

  if (horizontal === true) {
    if (x0 <= x1) {
      beginLoop = x0;
      endLoop = x1;

      beginX = x0;
      beginY = y0;
      endX = x1;
      endY = y1;
    } else {
      beginLoop = x1;
      endLoop = x0;

      beginX = x1;
      beginY = y1;
      endX = x0;
      endY = y0;
    }
  } else {
    if (y0 <= y1) {
      beginLoop = y0;
      endLoop = y1;

      beginX = x0;
      beginY = y0;
      endX = x1;
      endY = y1;
    } else {
      beginLoop = y1;
      endLoop = y0;

      beginX = x1;
      beginY = y1;
      endX = x0;
      endY = y0;
    }
  }

  if (step === 0) {
    return;
  }

  for (let currentStep = beginLoop; currentStep < endLoop; currentStep += step) {
    if (horizontal === true) {
      array.push([Math.round(currentStep * round) / round, Math.round(Math_LinearInterpolationY(beginX, beginY, endX, endY, currentStep) * round) / round]);
    } else {
      array.push([Math.round(Math_LinearInterpolationX(beginX, beginY, endX, endY, currentStep) * round) / round, Math.round(currentStep * round) / round]);
    }
  }

  return array;
}

export function DrawPolyQPd(start, end, staticIncrement, side) {
  let xy = [];
  let array = [];

  let dynamicInc = 0;
  let calculation;

  if (staticIncrement === 0) {
    return;
  }

  for (let index = start; index < end; index += dynamicInc) {
    xy = [];
    dynamicInc += staticIncrement;
    calculation = Math.sqrt((index / start) * (index / start) - end);

    if (side == "left") {
      xy.push(-calculation);
      xy.push(index);
    } else if (side == "right") {
      xy.push(calculation);
      xy.push(index);
    } else if (side == "both") {
      xy.push(-calculation);
      xy.push(index);
      xy.push(calculation);
      xy.push(index);
    }

    array.push(xy);
  }

  return array;
}
